import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

/* ================= TYPES ================= */

export interface PlatingRuleQueryModel {
  id?: number;
  panelId?: number;
  labId?: number;
  ordersSelectedOnPanelForNY?: number;
  ordersSelectedOnPanel?: number;
}

export interface GetAllPlatingRulePayload {
  pageNumber: number;
  pageSize: number;
  queryModel: PlatingRuleQueryModel;
  sortColumn?: string;
  sortDirection?: string;
}

export interface SavePlatingRulePayload {
  id: number;
  panelId: string;
  panelName?: string;
  labId: number;
  ordersSelectedOnPanelForNY: number;
  ordersSelectedOnPanel: number;
}

/* ================= API CALLS ================= */

export const GetAllPlatingRules = (payload: GetAllPlatingRulePayload) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.PlatingRule.GetAll}`,
    payload
  );
};

export const SavePlatingRule = (payload: SavePlatingRulePayload) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.PlatingRule.Save}`,
    payload
  );
};

export const DeletePlatingRule = (id: number) => {
  return HttpClient().get(
    `/${apiRoutes.OncologyCompendium.PlatingRule.Delete}/${id}`
  );
};

export const PanelsAgainstLabId = (labId: number | null) => {
  return HttpClient().get(
    `/${apiRoutes.OncologyCompendium.PlatingRule.PanelsAgainstLabId}${
      labId ? `?labId=${labId}` : ""
    }`
  );
};
/* ================= EXPORT SERVICE ================= */

const PlatingRuleService = {
  GetAllPlatingRules,
  SavePlatingRule,
  DeletePlatingRule,
  PanelsAgainstLabId,
};

export default PlatingRuleService;
